module.exports = __webpack_public_path__ + "static/img/legend_xg_spanish_vertical.ac54c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_spanish_vertical.png
// module id = bTCJ
// module chunks = 94